import api from '../../api';

const path = `/search`;

const getRentListRequest = (params) =>
    api.get(`${path}/rent/get`, {
        params,
    });

export { getRentListRequest };
